// extracted by mini-css-extract-plugin
export var connectionButton = "_b7-1";
export var rightPanel = "_b7-3";
export var stepDescription = "_b7-2";
export var stepIcon = "_b7-0";